import { EXTRACTION_META, VERDICT_META, type Verdict } from "../../shared/types";
import type { Stats } from "../api";

const ORDER: Verdict[] = ["safe", "suspicious", "malicious"];

/** Instrument readout window — numbers only, no prose. */
export function StatStrip({ stats }: { stats: Stats }) {
  const v = stats.byVerdict;
  const total = Math.max(1, stats.total);

  return (
    <div className="win flex flex-col">
      <div className="win-bar">
        <span>readout</span>
        <span className="hatch" />
      </div>

      <div className="flex border-b-[1.5px] border-ink">
        <div className="flex-1 border-r-[1.5px] border-ink px-2.5 py-1.5">
          <div className="label opacity-55">screened</div>
          <div className="mono text-[17px] font-bold tabular-nums leading-tight">{stats.total}</div>
        </div>
        <div className="flex-1 px-2.5 py-1.5">
          <div className="label opacity-55">median</div>
          <div className="mono whitespace-nowrap text-[17px] font-bold tabular-nums leading-tight">
            {stats.medianLatencyMs}ms
          </div>
        </div>
      </div>

      {/* distribution */}
      <div className="flex h-[13px] border-b-[1.5px] border-ink">
        {ORDER.map((k, i) => (
          <div
            key={k}
            className={i < 2 ? "border-r-[1.5px] border-ink" : ""}
            style={{ width: `${(v[k] / total) * 100}%`, background: VERDICT_META[k].accent }}
          />
        ))}
      </div>

      <div className="flex flex-col gap-1 px-2.5 py-2">
        {ORDER.map((k) => (
          <div key={k} className="mono flex items-center gap-2 text-[11px]">
            <span
              className="h-[9px] w-[9px] shrink-0 border-[1.5px] border-ink"
              style={{ background: VERDICT_META[k].accent }}
            />
            <span className="lowercase opacity-70">{k}</span>
            <span className="ml-auto tabular-nums font-bold">{v[k]}</span>
            <span className="w-9 text-right tabular-nums opacity-45">
              {Math.round((v[k] / total) * 100)}%
            </span>
          </div>
        ))}
      </div>

      {/* second axis */}
      <div className="flex flex-col gap-1 border-t-[1.5px] border-ink px-2.5 py-2">
        <div className="label opacity-55">extraction</div>
        {(["probing", "distilling"] as const).map((k) => (
          <div key={k} className="mono flex items-center gap-2 text-[11px]">
            <span
              className="h-[9px] w-[9px] shrink-0 border-[1.5px] border-ink"
              style={{ background: EXTRACTION_META[k].accent }}
            />
            <span className="lowercase opacity-70">{k}</span>
            <span className="ml-auto tabular-nums font-bold">{stats.byExtraction?.[k] ?? 0}</span>
            <span className="w-14 shrink-0 text-right opacity-45">{EXTRACTION_META[k].action}</span>
          </div>
        ))}
      </div>

      <div className="mono mt-auto flex flex-wrap gap-x-4 border-t-[1.5px] border-ink px-2.5 py-1.5 text-[10px]">
        <span className="whitespace-nowrap opacity-60">policy <b className="opacity-100">strict</b></span>
        <span className="whitespace-nowrap opacity-60">axes <b className="opacity-100">harm · extraction</b></span>
      </div>
    </div>
  );
}
